// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__-xtK1","noInteraction":"EventWrapper_noInteraction__6hmd7","pointerPassthrough":"EventWrapper_pointerPassthrough__2uZ59"};